<template>
  <div>
    <van-nav-bar
        left-arrow
        :title="departNotice.name"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>
    <div class="content">
      <div v-html="$imgCheck(departNotice.descn)"></div>
    </div>
  </div>
</template>

<script>
import {Cell, CellGroup, Field, Dialog, Button} from 'vant';
import {postAction} from '@/api/manage';
import {Toast} from 'vant';

export default {
  components: {
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      departNotice: {},
      mui: this.$route.query.mui,
    };
  },
  mounted() {
    var that = this;
    postAction('/web/api/index/shopNotice', {mui: this.mui}).then(function (response) {
      console.log(response.result)
      that.departNotice = response.result.dn
    })
  },
  methods: {}
};
</script>

<style lang="less">
.content {
  margin: 10px;
}

.content img {
  max-width: 100%;
}
</style>
